import type { RootState } from "types/redux";

// Bookmarks

export const getCanDisplayBookmarks = (state: RootState) => state.entities.permissions.bookmarks.display;

// Collections

export const getCanEditCollections = (state: RootState) => state.entities.permissions.collections.can_edit_collections;

export const getCanFeatureCollections = (state: RootState) => state.entities.permissions.collections.can_feature;

export const getCanListCollections = (state: RootState) => state.entities.permissions.collections.can_list;

// Communities

export const getCanEditCommunities = (state: RootState) => state.entities.permissions.communities.can_edit_communities;

// Create

export const getCanAccessCreate = (state: RootState) => state.entities.permissions.create.access;

export const getCreateMapCustomContentAccess = (state: RootState) =>
  state.entities.permissions.create.features.custom_content;

export const getCreateMapCustomKeyIssueAccess = (state: RootState) =>
  state.entities.permissions.create.features.custom_key_issues;

export const getCanAccessGenerativeMaps = (state: RootState) =>
  state.entities.permissions.create.features.generative_maps;

export const getCreateMapLimit = (state: RootState) => state.entities.permissions.create.features.map_limit;

export const getIsCreateMapRestricted = (state: RootState) =>
  state.entities.permissions.create.features.map_restriction;

export const getCreateMapShareSettingsAccess = (state: RootState) =>
  state.entities.permissions.create.features.map_set_sharing;

// Discover

export const getCanAccessDiscoverTMAdvancedMode = (state: RootState) =>
  state.entities.permissions.discover.features.advanced_mode;

export const getCanAccessBriefing = (state: RootState) => state.entities.permissions.discover.features.briefing;

export const getCanAccessTopicCustomContent = (state: RootState) =>
  state.entities.permissions.discover.features.custom_content;

export const getCanAccessTopicData = (state: RootState) => state.entities.permissions.discover.features.data;

export const getCanAccessDiscoverTopicDialogue = (state: RootState) =>
  state.entities.permissions.discover.features.dialogue;

export const getCanAccessTopicEvents = (state: RootState) => state.entities.permissions.discover.features.events;

export const getCanAccessDiscoverForumEvents = (state: RootState) =>
  state.entities.permissions.discover.features.forum_events;

export const getCanAccessDiscoverStakeholderProfile = (state: RootState) =>
  state.entities.permissions.discover.features.forum_experts;

export const getCanAccessDiscoverForumInitiatives = (state: RootState) =>
  state.entities.permissions.discover.features.forum_initiatives;

export const getCanUseTopicImageExport = (state: RootState) =>
  state.entities.permissions.discover.features.image_export;

export const getCanAccessTopicInitiatives = (state: RootState) =>
  state.entities.permissions.discover.features.initiatives;

export const getCanUseTopicPresentationExport = (state: RootState) =>
  state.entities.permissions.discover.features.presentation_export;

export const getCanAccessTopicPublications = (state: RootState) =>
  state.entities.permissions.discover.features.publications;

export const getCanAccessTopicStakeholders = (state: RootState) =>
  state.entities.permissions.discover.features.stakeholders;

export const getCanSeeSectionContent = (state: RootState) =>
  state.entities.permissions.discover.features.tab_content_visible;

export const getTMLicense = (state: RootState) => state.entities.permissions.discover.features.tm_license;

export const getCanAccessTopicVideos = (state: RootState) => state.entities.permissions.discover.features.videos;

export const getCanAccessLatestFeed = (state: RootState) =>
  getCanAccessTopicPublications(state) && getCanAccessTopicVideos(state) && getCanAccessTopicData(state);

// Global

export const getCanDisplayAppBanner = (state: RootState) => state.entities.permissions.global.features.app_banner;

export const getShouldShowBecomeMemberMarketing = (state: RootState) =>
  state.entities.permissions.global.features.become_member;

export const getShouldShowBecomeProMemberMarketing = (state: RootState) =>
  state.entities.permissions.global.features.become_pro_member;

export const getCanFollowTopic = (state: RootState) => state.entities.permissions.global.features.follow_topics;

export const getShouldDisplayNotifications = (state: RootState) =>
  state.entities.permissions.global.features.notifications;

export const getCanAccessTopicSignals = (state: RootState) => state.entities.permissions.global.features.signals;

// Knowledge

export const getCanAddKnowledge = (state: RootState) => state.entities.permissions.knowledge.can_add_knowledge;

export const getCanRejectKnowledge = (state: RootState) => state.entities.permissions.knowledge.can_reject_knowledge;

// Membership events

export const getHasAccessToMembershipEvents = (state: RootState) => state.entities.permissions.membership_events.access;

// Monitor

export const getCanAccessMonitor = (state: RootState) => state.entities.permissions.monitor.access;

// Sources

export const getCanEditSources = (state: RootState) => state.entities.permissions.sources.can_edit_sources;
export const getCanViewSources = (state: RootState) => state.entities.permissions.sources.can_view_sources;
